// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as TicketsRepoConfig from "./TicketsRepoConfig.bs.js";

var dummyRaiseTicketInfo = {
        "caller_number": "0000000000",
        "msisdn": "0000000000000",
        "crn": "CRN00000000",
        "location": "Surat",
        "order_stage": "Post End Job",
        "raised_by": "Customer",
      };

var dummyRaiseTicketIssues = {
        "issues": [
          "Behaviour Issue",
          "Cancel Request/Status",
          "Covid-19 Insurance Query",
          "Details Update Request",
          "Discount And Coupon",
          "Distance Fare",
          "Dry Run Incentive",
          "Fare Related Inquiry",
          "Helper/Labour Related Complaint",
          "Helper/Labour Related Query",
          "Mismatch in Number of Stops",
          "New Branding Request",
          "New Customer Prospect",
          "New Partner Prospect",
          "Not About This Order",
          "Not Receiving Enough Orders",
          "Number Not Reachable",
          "Online Payment Request/Status Inquiry",
          "Other Fare Components",
          "Other Issues",
          "Outstation Related Query",
          "Overloading/Oversizing/Unacceptable Good",
          "Partner App Error",
          "Partner Refuses",
          "Premium Subscription Purchase",
          "Rebranding Request",
          "Registration Fee",
          "Suspension/Penalty Related",
          "Ticket Already Raised",
          "Toll",
          "Unable To Book",
          "Underpayment/Overpayment",
          "Vehicle Allocation Query",
          "Vehicle Branding Audit Related",
          "Vehicle Related Issues",
          "Waiting Time Related",
          "Wallet Related Query",
          "Waypoint Related/Order Type",
          "RNR Related",
          "Porter Gold Cancel Request",
          "Dry Run Goodwill Disbursement",
          "Other Goodwill Disbursement"
        ]
      };

var dummyRaiseTicketActions = {
              "actions":[
              "Educated/Convinced",
              "Penalized/Suspended/Blacklist",
              "Goodwill Request/Manual Fare Adjustment",
              "Order Cancel","Waypoint Added",
              "Payment Link Sent","Escalate To",
              "Agent Error"]
              };

var dummyRaiseTicketResponse = {
          "ticket_id": "1234",
          "message": "Hi There",
        };

var dummyUpdateTicketResponse = {
          "case_number": "00000000",
          "crt_id": "ticket successfully updated",
        };

var dummyTicketsResponse = {
        "data": [
          // replicating ticket that are created using ATC and call dropped before submission 
          {
            "case_number": "00000000",
            "id": "50000000000000000",
            "status": "Open",
            "issues": [],
            "created_date": 1645595408
          },
          {
            "case_number": "00000000",
            "id": "000000000000000000",
            "city": "Bangalore",
            "status": "Open",
            "crn": "CRN00000000",
            "issues": [
              "Wallet Related Query",
              "Waypoint Related/Order Type",
              "Outstation Related Query"
            ],
            "created_date": 1645595404
          },
          {
            "case_number": "00000000",
            "id": "500000000000000000",
            "city": "Ahmedabad",
            "status": "Open",
            "crn": "CRN00000000",
            "issues": [
              "Waiting Time Related",
              "Mismatch in Number of Stops",
              "Helper/Labour Related Query"
            ],
            "created_date": 1644915356
          },
          {
            "case_number": "00000000",
            "id": "000000000000000000",
            "city": "Bangalore",
            "status": "Open",
            "crn": "CRN00000000",
            "issues": [
              "Ticket Already Raised",
            ],
            "created_date": 1644912913
          },
          {
            "case_number": "00000000",
            "id": "000000000000000000",
            "city": "Kolkata",
            "status": "Closed",
            "crn": null,
            "issues": [
              "Discount And Coupon",
              "Online Payment Request/Status Inquiry"
            ],
            "created_date": 1644912877
          },
          {
            "case_number": "00000000",
            "id": "000000000000000000",
            "city": "Bangalore",
            "status": "Closed",
            "crn": "CRN00000000",
            "issues": [
              "Discount And Coupon",
              "Dry Run Incentive",
              "Not About This Order",
              "Online Payment Request/Status Inquiry"
            ],
            "created_date": 1644912531
          }
        ],
        "total_count": 6,
        "offset": {
          "value": "end_of_result"
        }
      };

var dummyTicket = {
        "data": {
          "case_number": "00000000",
          "city": "Bangalore",
          "status": "Open",
          "crn": null,
          "created_date": 1658838638193,
          "msisdn": "0000000000000",
          "type": "Issue",
          "raised_by": "Customer",
          "escalate_to": null,
          "caller_number": "0000000000",
          "order_stage": null,
          "author": "aman@xyz.com",
          "issues": [
            "Wallet Related Query",
            "Waypoint Related/Order Type",
            "Outstation Related Query"
          ],
          "actions_taken": [
            "Escalate To",
            "Order Cancel",
            "Waypoint Added"
          ],
          "issue_comment": "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enimvelit mollit. Exercitation veniam consequat sunt nostrud amet.",
          "action_comment": "Test_action",
          "case_comments": [{
            "body": "Some Comments!",
            "author": "Mike Ross",
            "created_at": 1658838638193
          },
          {
            "body": "Some Comments!",
            "author": "Harvey Specter",
            "created_at": 1658838638193
          }]
        }
      };

function fetchTicketInfo(_crn, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyRaiseTicketInfo
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(TicketsRepoConfig.TicketsInfoResponseConverter.execute, result);
                        });
            });
}

function fetchTicketIssues(_orderStage, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyRaiseTicketIssues
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(TicketsRepoConfig.TicketsIssuesResponseConverter.execute, result);
                        });
            });
}

function fetchTicketActions(_orderStage, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyRaiseTicketActions
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(TicketsRepoConfig.TicketsActionsResponseConverter.execute, result);
                        });
            });
}

function raiseTicket(_ticket, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyRaiseTicketResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(TicketsRepoConfig.TicketRequestResponseConverter.execute, result);
                        });
            });
}

function updateTicket(_ticket, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyUpdateTicketResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(TicketsRepoConfig.UpdateTicketRequestResponseConverter.execute, result);
                        });
            });
}

function fetchTickets(_request, _offset, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyTicketsResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(TicketsRepoConfig.TicketsResponseConverter.execute, result);
                        });
            });
}

function fetchTicket(_case_number, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyTicket
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(TicketsRepoConfig.TicketResponseConverter.execute, result);
                        });
            });
}

var TicketsRepo = {
  dummyRaiseTicketInfo: dummyRaiseTicketInfo,
  dummyRaiseTicketIssues: dummyRaiseTicketIssues,
  dummyRaiseTicketActions: dummyRaiseTicketActions,
  dummyRaiseTicketResponse: dummyRaiseTicketResponse,
  dummyUpdateTicketResponse: dummyUpdateTicketResponse,
  dummyTicketsResponse: dummyTicketsResponse,
  dummyTicket: dummyTicket,
  fetchTicketInfo: fetchTicketInfo,
  fetchTicketIssues: fetchTicketIssues,
  fetchTicketActions: fetchTicketActions,
  raiseTicket: raiseTicket,
  updateTicket: updateTicket,
  fetchTickets: fetchTickets,
  fetchTicket: fetchTicket
};

export {
  TicketsRepo ,
  
}
/* TicketsRepoConfig Not a pure module */
